<template>
	<div class="login-pass-wrap">
		<div class="part1" v-if="showPart==1">
			<div class="greet-text">
				<p>验证码登录</p>
			</div>
			<div class="edit-account">
				<ul>
					<li>
						<input type="tel" placeholder="请输入手机号" v-model="tel"/>
					</li>
				</ul>
				<div class="login-btn">
					<button @click="toPart2">获取验证码</button>
				</div>
			</div>
		</div>
		<div class="part2" v-if="showPart==2">
			<div class="greet-text">
				<p>验证码登录</p>
				<p class="tips">短信验证码已发送至{{showTel}}</p>
			</div>
			<div class="edit-account">
				<ul>
					<li>
						<input type="text" placeholder="请输入短信验证码" v-model="code"/>
						<span class="get-code">
							<span v-if="codeFlag" @click="codeFlag&&getCode()">重新获取</span>
							<span v-else>{{seconds}}s</span>
						</span>
					</li>
				</ul>
				<div class="login-btn">
					<button @click="submitLogin">验证并登录</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"login-code",
		data(){
			return{
				tel:"",
				codeFlag: true,
				code:"",
				codeNum:"",
				seconds: 60,
				showPart: 1,
			}
		},
		computed:{
			showTel() {
				let t = this.tel.substr(0, 3) + "****" + this.tel.substr(7);
				return t;
			},
		},
		watch: {
			
		},
		methods:{
			toPart2(){
				if(!(/^1[34578]\d{9}$/.test(this.tel))||this.pass=="") {
					this.$toast({
						message: "请检查手机号是否正确",
						position: "bottom",
						duration: 3000
					})
				}else{
					this.getCode();
					this.showPart = 2;
				}
			},
			getCode() {
				if(!this.codeFlag) {
					this.$toast({
						message: "操作过于频繁！",
						position: "bottom",
						duration: 3000
					});
				} else if(!(/^1[34578]\d{9}$/.test(this.tel))) {
					this.$toast({
						message: "请检查手机号是否正确",
						position: "bottom",
						duration: 3000
					});
				} else {
					this.$axios({
						url:'Sms/mobilePhoneCheckCode',
						method:"post",
						data:{
							phone:this.tel,
							type:"B"
						}
					}).then(res=>{
						if(res.data.code==200){
							this.$toast({message:"验证码发送成功！",position:"bottom",duration:3000})
							this.codeNum = res.data.data.msgTxt;
							console.log(this.codeNum,this.code);
							this.codeFlag = false;
							this.culTime();
						}else{
							this.$toast({message:"验证码发送失败！请重试！",position:"bottom",duration:3000});
							this.codeFlag = true;
						}
					}).catch(err=>{
						console.log(err)
					})
				}

			},
			culTime() {
				let _this = this;
				let t = setInterval(function() {
					if(_this.seconds > 0) {
						_this.seconds--
					} else {
						_this.seconds = 60;
						_this.codeFlag = true;
						clearInterval(t)
					}

				}, 1000)
			},
			submitLogin(){
				console.log(this.tel,this.pass);
				if(!(/^1[34578]\d{9}$/.test(this.tel))||this.pass=="") {
					this.$toast({
						message: "请检查手机号、密码是否正确填写",
						position: "bottom",
						duration: 3000
					})
				} else {
					this.$axios({
						url:"User/login",
						method:"post",
						data:{
							phone:this.tel,
							check_code:this.code,
							type:"code",
							login_type:2,
						}
					}).then(res=>{
						console.log(res);
						if(res.data.code==200){
							this.$toast({
								message: "登录成功",
								position: "bottom",
								duration: 3000
							});
							this.$store.commit("getUserId",res.data.data.uid);
							if(window.localStorage){
								localStorage.setItem("yushuiyuanid",res.data.data.uid);
							}else{
							    document.cookie = "yushuiyuanid="+res.data.data.uid;
							}
							this.$router.push({name:"mine"})
						}
					}).catch(err=>{
						console.log(err)
					})
				}
			}
		}
	}
</script>

<style scoped>
	.login-pass-wrap{
		padding: 3rem 1.5rem 0;
	}
	.greet-text{
		font-size: 1.5rem;
		color: #282828;
		line-height: 2.5rem;
		margin-bottom: 2rem;
	}
	.greet-text .tips{
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.edit-account li{
		border-bottom: 1px solid #f3f3f3;
		position: relative;
	}
	.edit-account li input{
		width: 100%;
		height: 2.5rem;
		border: 0;
		background: none;
		outline: 0;
		padding: 0 0.5rem;
		font-size: 0.8rem;
	}
	.edit-account li .get-code {
		position: absolute;
		font-size: 0.7rem;
		background: rgba(255, 97, 97, .6);
		padding: 0.2rem 0.6rem;
		color: #fff;
		border-radius: 3px;
		right: 0;
		top: 0.5rem;
	}
	
	.edit-account li .icon {
		position: absolute;
		right: 0;
		top: 0.5rem;
	}
	
	.edit-account li .icon img {
		width: 1.5rem;
	}
	
	.edit-account li .get-code:active {
		opacity: 0.7;
	}
	.options{
		font-size: 0.6rem;
		color: #282828;
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 2.4rem;
		padding: 0 0.5rem;
	}
	.options span:active{
		opacity: 0.7;
	}
	.login-btn{
		padding: 1rem 0.5rem;
	}
	.login-btn button{
		width: 100%;
		height: 2.5rem;
		color: #7b7b7b;
		font-size: 0.8rem;
		background: #eee;
		border: 0;
		outline: 0;
		border-radius: 5px;
	}
	.other-login{
		position: relative;
		width: 100%;
		bottom: 0.5rem;
		left: 0;
		margin-top: 6rem;
	}
	.other-login .title{
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 2rem;
	}
	.other-login .title .text{
		padding: 0 1rem;
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.other-login .title .line{
		flex: 1;
		height: 1px;
		border-bottom: 1px solid #f3f3f3;
	}
	.other-login .login-btns{
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 0.5rem;
	}
	.other-login .login-btns li{
		padding: 0.5rem;
		margin: 0 0.5rem;
	}
	.other-login .login-btns li:active{
		background: #fafafa;
	}
	.other-login .login-btns img{
		width: 1.5rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/LoginCode.vue